import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getUserInfoFromKeyCloak = () => {
    return axios.get(`${BASE_URL}/api/user/info`);
};
